import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
import { TOTAL_SPOTS, useSpotsLeft } from "../hooks/useSpotsLeft";
type ScarcityBarProps = {
  tone?: "light" | "dark";
};
export function ScarcityBar({
  tone = "light"
}: ScarcityBarProps) {
  const spots = useSpotsLeft();
  const filled = (TOTAL_SPOTS - spots) / TOTAL_SPOTS * 100;
  const dark = tone === "dark";
  return <div className={`mx-auto mt-6 w-full max-w-xl rounded-2xl p-4 ${dark ? "bg-navy-800" : "bg-alert-soft"}`} data-id="element-58" data-mp="2b5p2ebajdc45">
      <div className="flex items-center justify-between gap-3" data-id="element-59" data-mp="2g6mh2dwc7o0w">
        <p className={`flex items-center gap-1.5 text-sm font-extrabold sm:text-base ${dark ? "text-white" : "text-ink"}`} data-id="element-60" data-mp="226li53zmuqo2">
          <FlameIcon className="h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-61" data-mp="2766gpdaw4x09" />
          Only <span className="text-alert" data-id="element-62" data-mp="efi6b82jhpp">{spots} spots</span> left at this price
        </p>
        <span className={`shrink-0 text-sm font-bold tabular-nums ${dark ? "text-gold" : "text-alert"}`} data-id="element-63" data-mp="5ebju3tamx23">{Math.round(filled)}%</span>
      </div>
      <div className={`mt-3 h-4 w-full overflow-hidden rounded-full ${dark ? "bg-navy" : "bg-white"}`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(filled)} aria-label="Promotional spots claimed" data-id="element-64" data-mp="33lbnkkdq6jzq">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: "40%"
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-65" data-mp="38e4w7jcbech3" />
      </div>
      <p className={`mt-2 text-xs font-medium ${dark ? "text-brand-sky" : "text-muted"}`} data-id="element-66" data-mp="2un84duq7pzb3">
        When the remaining spots are claimed, the promotional price of $27 ends.
      </p>
    </div>;
}